export default "__VITE_ASSET__iwcUy7Jk__"